import httpClient from "@/plugins/axios";
import resource_types from "@/@core/utils/resource_types";

export const getResourceFolders = async (page) => {
    const response = await httpClient.get(`/admin/v1/resource-folders/?page=${page}`);
    return response;
}

export const getResourceFolder = async (id) => {
    const response = await httpClient.get(`/admin/v1/resource-folders/${id}/`);
    return response;
}

export const saveResourceFolder = async (folder) => {
    if (folder.id) {
        return await updateResourceFolder(folder);
    } else {
        return await createResourceFolder(folder);
    }
};

export const createResourceFolder = async (folder) => {
    const response = await httpClient.post('/admin/v1/resource-folders/', folder);
    return response;
}

export const updateResourceFolder = async (folder) => {
    const response = await httpClient.put(`/admin/v1/resource-folders/${folder.id}/`, folder);
    return response;
}

export const deleteResourceFolder = async (id) => {
    const response = await httpClient.delete(`/admin/v1/resource-folders/${id}/`);
    return response;
}

export const getResources = async (page, pageSize = 10, folderId = null) => {
    let url = `/admin/v1/resources/?page=${page}&page_size=${pageSize}`;
    if (folderId) {
        url += `&folder=${folderId}`;
    }
    const response = await httpClient.get(url);
    return response;
}

export const download = async (id) => {
    const response = await httpClient.get(`/v1/resources/${id}/view/?admin_view=1`,
        {
            responseType: 'blob',
        });
    return response;
}

export const getResource = async (id) => {
    const response = await httpClient.get(`/admin/v1/resources/${id}/`);
    return response;
}

export const saveResource = async (resource) => {
    if (resource.id) {
        return await updateResource(resource);
    }
    else {
        return await insertResource(resource);
    }
};

const insertResource = async (resource) => {
    const formData = getFormData(resource);

    const response = await httpClient.post('/admin/v1/resources/', formData);
    return response;
}

const updateResource = async (resource) => {
    const formData = getFormData(resource);

    const response = await httpClient.put(`/admin/v1/resources/${resource.id}/`, formData);
    return response;
}

export const deleteResource = async (id) => {
    const response = await httpClient.delete(`/admin/v1/resources/${id}/`);
    return response;
}

const getFormData = (resource) => {
    const formData = new FormData()
    formData.append('id', resource.id)
    formData.append('group', resource.group)
    formData.append('resource_type', resource.resource_type)
    formData.append('published', resource.published)
    formData.append('require_acknowledgment', resource.require_acknowledgment);
    formData.append('acknowledgment_version', resource.acknowledgment_version);

    if (resource.folder)
        formData.append('folder', resource.folder)
    if (
        resource.resource_type === resource_types.document.value
    ) {
        if (resource.file) {
            formData.append('file', resource.file)
        }
        formData.append('filename', resource.filename)
        formData.append('link', '')
    } else {
        formData.append('link', resource.link)
        formData.append('filename', '')
    }

    let translations = {}
    Object.keys(resource.translations).forEach((lang) => {
        if (resource.translations[lang].title && resource.translations[lang].description) {
            translations[lang] = {
                title: resource.translations[lang].title,
                description: resource.translations[lang].description,
                acknowledgment_description: resource.translations[lang].acknowledgment_description,
            }
        }
    })
    formData.append('translations', JSON.stringify(translations))

    return formData;
}


